import { Button, Alert, Modal } from '@nackle/paper';
import React, { Component, ReactNode } from 'react';
export interface ConfirmParams {
    readonly modalId: string;
    readonly message: ReactNode;
    readonly primaryButtonText?: string;
    readonly cancelButtonText?: string;
    readonly onConfirm: () => void;
    readonly onCancel?: () => void;

    /** For unit tests mostly **/
    readonly usePortal?: any;
}

interface DialogProps extends ConfirmParams {
    onCloseAnimationComplete: (modalId: string) => void;
}

interface DialogState {
    error: unknown | null;
    isOpen: boolean;
    isLoading: boolean;
}

export class ConfirmDialog extends Component<DialogProps, DialogState> {
    unmounted = false;

    componentWillUnmount(): void {
        this.unmounted = true;
    }

    public state: DialogState = {
        error: null,
        isOpen: true,
        isLoading: false,
    };

    render () {
        const {
            cancelButtonText = 'Cancel',
            primaryButtonText = 'OK',
            modalId,
            message,
            usePortal,
        } = this.props;

        const {
            error,
            isOpen,
            isLoading,
        } = this.state;
        return (
            <>
                <Modal
                    className="confirm-modal"
                    visible={isOpen}
                    onCancel={this.handleCancel}
                    afterClose={this.handleCloseAnimationComplete}
                    closable={false}
                    footer={null}
                    {...usePortal}
                    style={{top: 400}}
                >
                    {/* This wrapper div exists so unit tests can locate the modal */}
                    <div id={`modal-${modalId}`}>
                        <div className="dialog-body">
                            { error !== null && <Alert message="An error occurred." type="warning"/> }
                            {message}

                           
                        </div>

                        <div className="dialog-footer-delete">
                            <div className="dialog-footer-actions" style={{display: 'inline-flex'}}>
                                <Button
                                    disabled={isLoading}
                                    type="primary"
                                    id="confirm-dialog-confirm"
                                    onClick={this.handleAccept}
                                    danger
                                    block={true}
                                    shape="round"
                                    style={{marginRight: 10}}
                                    >
                                        {primaryButtonText}
                                    </Button>
                                <Button
                                    disabled={isLoading}
                                    id="confirm-dialog-cancel"
                                    onClick={this.handleCancel}
                                    block={true}
                                    shape="round"
                                >
                                    {cancelButtonText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }

    private handleAccept = async () => {
        this.setState({ isLoading: true });
        try {
            await this.props.onConfirm();
        } catch (error) {
            this.setState({ error, isLoading: false });
            throw error;
        }
        this.setState({ isOpen: false, isLoading: false });
    };

    private handleCancel = async () => {
        try {
            if (this.props.onCancel) {
                await this.props.onCancel();
            }
        } finally {
            this.setState({ isOpen: false, isLoading: false });
        }
    };

    private handleCloseAnimationComplete = () => this.props.onCloseAnimationComplete(this.props.modalId);
}
